<template>
    <v-container>
        <v-row>
            <v-col cols="12" justify="center" align="center">
                <v-skeleton-loader ref="skeleton" type="heading"></v-skeleton-loader>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" justify="center" align="center">
                <v-skeleton-loader ref="skeleton" type="heading"></v-skeleton-loader>
                <v-skeleton-loader ref="skeleton" type="list-item-three-line"></v-skeleton-loader>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" justify="start" align="start">
                <v-skeleton-loader ref="skeleton" type="heading"></v-skeleton-loader>
                <v-skeleton-loader ref="skeleton" type="list-item-three-line"></v-skeleton-loader>
                <v-skeleton-loader ref="skeleton" type="list-item-three-line"></v-skeleton-loader>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" justify="start" align="start">
                <v-skeleton-loader ref="skeleton" type="list-item-two-line"></v-skeleton-loader>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" justify="start" align="start">
                <v-skeleton-loader ref="skeleton" type="button"></v-skeleton-loader>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
  name: "WorkTopicSkeleton"
};
</script>